import { Link } from 'gatsby';
import Img from 'gatsby-image';
import _ from 'lodash';
import { lighten } from 'polished';
import React from 'react';
import { css } from '@emotion/react';
import { colors } from '../../styles/colors';
import { PageContext } from '../../templates/toolsKit/toolsInKit';
export interface CardProps {
  post: PageContext;
}

export const Card: React.FC<CardProps> = ({ post}) => {

  return (

    <section className="my-5 guide section-bg" >
      <div className="container">

        <div className="row">
          <div className="img-wrapper col-lg-6 video-box">
            <Link to={`/tools-kit/${_.kebabCase(post.frontmatter.tags[0])}`}>
              {post.frontmatter?.image?.childImageSharp?.fluid && (
                <Img
                  alt={`${post.frontmatter.title} cover image`}
                  style={{ height: '100%' }}
                  fluid={post.frontmatter.image.childImageSharp.fluid}
                  className="zoom-on-hover"
                  />
              )}
            </Link>

          </div>

          <div className="col-lg-6 d-flex flex-column justify-content-center p-5">
            <h4 style={{textAlign: "center", fontSize:'3rem'}} className="title"><Link to={`/tools-kit/${_.kebabCase(post.frontmatter.tags[0])}`}>{post.frontmatter.title}</Link></h4>
            <p style={{textAlign: "center"}}className="description">{post.frontmatter.excerpt || post.excerpt}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export const StaticAvatar = css`
  display: block;
  overflow: hidden;
  margin: 0 0 0 -6px;
  width: 34px;
  height: 34px;
  border: #fff 2px solid;
  border-radius: 100%;

  @media (prefers-color-scheme: dark) {
    /* border-color: color(var(--darkgrey) l(+2%)); */
    border-color: ${lighten('0.02', colors.darkgrey)};
  }
`;

export const AuthorProfileImage = css`
  display: block;
  width: 100%;
  height: 100%;
  /* background: color(var(--lightgrey) l(+10%)); */
  background: ${lighten('0.1', colors.lightgrey)};
  border-radius: 100%;
  object-fit: cover;

  @media (prefers-color-scheme: dark) {
    background: ${colors.darkmode};
  }
`;
